var _defs, _g, _path, _path2, _circle, _path3, _rect, _rect2, _rect3, _rect4, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRedpointLogoSvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 452 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#d50000;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m201.06,92.82h-10.94l-5.88-9.43h-12.56v9.43h-8.18v-18.22h22.99c2.53,0,4.5-1.55,4.5-4,0-2.77-1.7-4.16-4.5-4.16h-22.99l5.33-9.27h16.98c6,0,13.59,2.56,13.59,12.73,0,5.54-2.57,10.12-6.91,11.3.91.91,1.9,2.18,3.71,4.69l4.86,6.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m234.67,83.66l-5.25,9.16h-25.44v-35.64h30.61l-5.29,9.27h-17.1v4.26h20.93l-4.7,8.1h-16.23v4.85h22.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m255.17,92.82h-17.69v-22.22h8.22v13.05h9.48c4.54,0,7.82-3.41,7.82-8.52s-3.4-8.68-7.82-8.68h-17.69l5.21-9.27h12.48c9.24,0,15.92,7.19,15.92,17.48s-6.75,18.17-15.92,18.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m297.11,83.71h-13.82v9.11h-8.14v-18.22h22.75c2.53,0,3.99-1.65,3.99-4.1s-1.46-4.05-3.99-4.05h-22.75l5.41-9.27h16.59c8.18,0,12.95,5.43,12.95,13.37s-4.78,13.16-12.99,13.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m352.05,74.97c0,12.73-6.48,18.43-19.31,18.43s-19.31-5.7-19.31-18.43,6.44-18.38,19.31-18.38,19.31,5.65,19.31,18.38Zm-8.14,0c0-7.67-2.96-9.11-11.18-9.11s-11.18,1.44-11.18,9.11,2.96,9.16,11.18,9.16,11.18-1.49,11.18-9.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m364.49,92.82h-8.18v-35.64h8.18v35.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m393.08,91.49l-16.19-19.61v20.94h-7.43v-29.57c0-4.74,2.13-6.66,4.46-6.66.99,0,1.98.32,3.28,1.92l16.19,19.61v-20.94h7.46v29.52c0,4.74-2.13,6.71-4.5,6.71-1.03,0-2.01-.32-3.28-1.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m438.5,57.18l-5.29,9.27h-9.44v26.37h-8.18v-26.37h-12.4l5.29-9.27h30.02Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.5,74.19s-5,25-41,40c0,0,38-8,41-23.72,4,15.72,41,23.72,41,23.72-36-15-41-40-41-40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m93.5,50.19s-7,31-35,49c0,0,22-4,35-19.72,15,22.72,51,33.72,51,33.72-36-15-51-63-51-63Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 42.42,
    cy: 59.82,
    r: 4.87
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m33.61,78.96c-.47.91.07,2.02,1.09,2.19l1.46.25c.68-.04,1.65.9,2.01,1.47l2.17,4.1c.61.99.93.71,2.09.7,4.28-.05-.13,3.75-2.09,4.87-1.6.92-3.32-4.29-4.19-6.4-.31-.76-1.1-1.2-1.91-1.08l-4.38-.49c-.24-.03-.48-.01-.7.08-.55.24-.94.79-.95,1.42l-1.72,14.17c-.02.68.41,1.28,1.05,1.53,1.31.51,1.52,1.16,1.4,1.68s-.61.93-1.15,1.04c-8.49,1.8-5.42-4.07-4.57-6.75.71-2.23,1.02-12.33,1.1-16.02,0-.27.08-.53.23-.76l10.16-16.44c.43-.69,1.33-.92,2.04-.52l2.34,1.34c.71.4.97,1.29.59,2.01l-6.05,11.59Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 26.66,
    y: 45.63,
    width: 3.03,
    height: 42.24,
    rx: 1.16,
    ry: 1.16,
    transform: "translate(39.41 -4.83) rotate(31.8)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 25.56,
    y: 40.02,
    width: 3.03,
    height: 43.48,
    rx: 1,
    ry: 1,
    transform: "translate(36.61 -5) rotate(31.8)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20.19,
    y: 33.47,
    width: 7.52,
    height: 44.58,
    rx: 2.59,
    ry: 2.59,
    transform: "translate(32.98 -4.25) rotate(31.8)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 24.45,
    y: 64.06,
    width: 6.27,
    height: 17.71,
    transform: "translate(42.57 -3.59) rotate(31.8)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m50.78,70.26c.67-.4,1.26.91-.7,2.09-3.48,2.09-6.65,1.96-6.65,1.96,0,0-7.28-1.26-7.97-4.74l2.12-2.19s3.46,3.59,6.24,4.28c0,0,3.48.7,6.96-1.39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedpointLogoSvgFile);
export default __webpack_public_path__ + "static/media/redpoint_logo_svg_file.57f544d6b69412fd6b962ea3c03b5f07.svg";
export { ForwardRef as ReactComponent };